import { createContext, useContext } from 'react';

export const TaskEstimateRowContext = createContext();

export const useTaskEstimateRowContext = () =>
  useContext(TaskEstimateRowContext);

export default TaskEstimateRowContext;
